/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "opentringapi",
            "endpoint": "https://mpu43ss4q3.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://k5gqtqx3uzan7g43suhnvdezzi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-lsemcs3k6bb3zmf6y6ckdx6xea",
    "aws_cognito_identity_pool_id": "us-east-1:ce51d757-9c04-4bae-82fe-ed28318174d5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_qdVSlDLYv",
    "aws_user_pools_web_client_id": "5iqg3ops4ooekrv1qjuqqrtphj",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
